import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { loadGallery } from '../../actions/gallery';
import '../../CSS/Gallery.css';

const Gallery = ({gallery: {images, loading}, loadGallery}) => {

    useEffect(() => {
      loadGallery()
    }, [loadGallery])
    
  return (
    <div className='grid-wrapper container'>
        {
            images.map( img =>
            <div className={img.imgtype} data-aos='zoom-in-up'>
                <img src={img.imgurl} alt={img.imgalt} />
            </div>
            )
        }
    </div>
  )
}

Gallery.propTypes = {
    gallery: propTypes.object.isRequired,
    loadGallery: propTypes.func.isRequired
}

const mapStateToProps = state => ({
    gallery: state.gallery
})

export default connect(mapStateToProps, {loadGallery})(Gallery);